import { ActionCard } from './ActionCard'
import { ObjectTypes } from './ConnectToCrmWidget'

export enum IntegrationType {
  hubSpot = 'HubSpot',
  salesforce = 'Salesforce',
  pipedrive = 'Pipedrive',
  smartWe = 'SmartWe',
  taifun = 'Taifun',
  channelPrm = 'ChannelPRM',
  community = 'Community',
  microsoftDynamics = 'MicrosoftDynamics',
  custom = 'Custom',
}

export type CrmObject = {
  type: CrmObjectType
  name: string
}

export enum CrmObjectType {
  company = 'Company',
  contact = 'Contact',
  deal = 'Opportunity',
  lead = 'Lead',
}

export type MappingItem = {
  crmObjectType: CrmObjectType
  acName: string // Object Id
  acDisplayName: string | undefined // Object Name
  crmName: string
  crmDisplayName: string | undefined
  syncToCrm: boolean
  syncToAc: boolean
  syncOnCreate: boolean
  syncOnUpdate: boolean
  mandatory: boolean
  values: Array<MappingItemValue>
  type: string
}

export type MappingItemValue = {
  acName: string // Object Id
  acDisplayName: string | undefined // Object Name
  crmName: string
  crmDisplayName: string | undefined
}

export enum MappingItemAction {
  create = 'create',
  update = 'update',
}

export type MappingExportData = {
  actionCardData: ActionCard
  mappingItems: MappingItem[]
}

export interface IntegrationDetails {
  id: string
  type: IntegrationType
  workspaceId?: string
  organizationId?: string
  modifiedAt: string
  name?: string
  url?: string
  params?: KeyValuePair[]
  body?: KeyValuePair[]
  headers?: KeyValuePair[]
}

export interface IntegrationMappingDetails {
  id: string
  type: IntegrationType
  integrationId: string
  templateId: string
  modifiedAt: string
  json: MappingItem[]
}

export interface KeyValuePair<K = string, V = string> {
  key: K
  value: V
}

export type CustomIntegrationRequestData = {
  action: 'find' | 'create' | 'sync' | 'onChange'
  objects: {
    id?: string
    url?: string
    type: ObjectTypes
    fields: {
      field: string
      value: unknown
    }[]
  }[]
}

export type CustomIntegrationResponseItem = {
  id: string
  url: string
  type: CrmObjectType
  name: string
  email?: string
}

export type CustomIntegrationResponseData = CustomIntegrationResponseItem[]
